/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
import axios from 'axios';

// Get IP
export function getIpAddressOld(callback) {
  function response(s) {
    callback(window.userip);

    s.onload = s.onerror = null;
    document.body.removeChild(s);
  }

  function trigger() {
    window.userip = false;

    const s = document.createElement('script');
    s.async = true;
    s.onload = () => {
      response(s);
    };
    s.onerror = () => {
      response(s);
    };

    s.src = 'https://l2.io/ip.js?var=userip';
    document.body.appendChild(s);
  }

  if (/^(interactive|complete)$/i.test(document.readyState)) {
    trigger();
  } else {
    document.addEventListener('DOMContentLoaded', trigger);
  }
}
export async function getIpAddress() {
  try {
    const {
      data: { ip },
    } = await axios.get('https://api.ipify.org/?format=json');
    return ip;
  } catch (e) {
    return 'Block IP';
  }
}
// Get Internal IP
export function getIpInternalAddress(callback) {
  // compatibility for firefox and chrome
  const myPeerConnection =
    window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
  // eslint-disable-next-line new-cap
  const pc = new myPeerConnection({
    iceServers: [],
  });
  const noop = () => {};
  const localIPs = {};
  const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;

  function iterateIP(ip) {
    if (!localIPs[ip]) callback(ip);
    localIPs[ip] = true;
  }

  // create a bogus data channel
  pc.createDataChannel('');

  // create offer and set local description
  pc.createOffer(sdp => {
    sdp.sdp.split('\n').forEach(line => {
      if (line.indexOf('candidate') < 0) return;
      line.match(ipRegex).forEach(iterateIP);
    });

    pc.setLocalDescription(sdp, noop, noop);
  }, noop);

  // listen for candidate events
  pc.onicecandidate = function(ice) {
    if (
      !ice ||
      !ice.candidate ||
      !ice.candidate.candidate ||
      !ice.candidate.candidate.match(ipRegex)
    )
      return;
    ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
  };
}

export function getCanalNome(id) {
  switch (id) {
    case 1:
      return 'Administrativo';
    case 3:
      return 'PaP';
    case 5:
      return 'Loja Propria';
    case 6:
      return 'Parceiro';
    case 7:
      return 'Televendas';
    case 8:
      return 'Vivo Prime';
    case 9:
      return 'OVVI';
    default:
      return null;
  }
}

export const promisify = value => {
  if (value.then) {
    return value;
  }

  if (typeof value === 'function') {
    const payload = value();

    return payload.then ? payload : Promise.resolve(payload);
  }

  return Promise.resolve(value);
};

export function currentDate() {
  const d = new Date();
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join('');
}

export function getUfId(sigla) {
  const UFs = [
    { id: 1, nome: 'Acre', sigla: 'AC' },
    { id: 2, nome: 'Alagoas', sigla: 'AL' },
    { id: 3, nome: 'Amazonas', sigla: 'AM' },
    { id: 4, nome: 'Amapá', sigla: 'AP' },
    { id: 5, nome: 'Bahia', sigla: 'BA' },
    { id: 6, nome: 'Ceará', sigla: 'CE' },
    { id: 7, nome: 'Distrito Federal', sigla: 'DF' },
    { id: 8, nome: 'Espírito Santo', sigla: 'ES' },
    { id: 9, nome: 'Goiás', sigla: 'GO' },
    { id: 10, nome: 'Maranhão', sigla: 'MA' },
    { id: 11, nome: 'Minas Gerais', sigla: 'MG' },
    { id: 12, nome: 'Mato Grosso do Sul', sigla: 'MS' },
    { id: 13, nome: 'Mato Grosso', sigla: 'MT' },
    { id: 14, nome: 'Pará', sigla: 'PA' },
    { id: 15, nome: 'Paraíba', sigla: 'PB' },
    { id: 16, nome: 'Pernambuco', sigla: 'PE' },
    { id: 17, nome: 'Piauí', sigla: 'PI' },
    { id: 18, nome: 'Paraná', sigla: 'PR' },
    { id: 19, nome: 'Rio de Janeiro', sigla: 'RJ' },
    { id: 20, nome: 'Rio Grande do Norte', sigla: 'RN' },
    { id: 21, nome: 'Rondônia', sigla: 'RO' },
    { id: 22, nome: 'Roraima', sigla: 'RR' },
    { id: 23, nome: 'Rio Grande do Sul', sigla: 'RS' },
    { id: 24, nome: 'Santa Catarina', sigla: 'SC' },
    { id: 25, nome: 'Sergipe', sigla: 'SE' },
    { id: 26, nome: 'São Paulo', sigla: 'SP' },
    { id: 27, nome: 'Tocantins', sigla: 'TO' },
  ];
  return sigla ? UFs.find(item => item.sigla.toLowerCase() === sigla.toLowerCase()).id : null;
}
